import { ProductionDeviationState } from "features/CenterContent/RoleContent/ProductionDeviation/types/responseSchema";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { DropsTooltip } from "shared/components/Spor";
import colors from "shared/theme/colors";
import styled, { useTheme } from "styled-components";

const Badge = styled.div<{ $backgroundColor: string; $color: string }>`
  display: flex;
  align-items: center;
  justify-content: center;

  min-width: 44px;
  width: fit-content;
  height: 16px;
  padding: 0 6px;
  border-radius: 1px 12px 12px 1px;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  white-space: nowrap;

  background-color: ${({ $backgroundColor }) => $backgroundColor};
  color: ${({ $color }) => $color};
`;

type AffectedTrainBadgeProps = {
  trainId: string;
  state: ProductionDeviationState;
};

export const AffectedTrainBadge: FC<AffectedTrainBadgeProps> = ({
  trainId,
  state,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isOpen = state === "OPEN";
  return (
    <DropsTooltip hasArrow label={isOpen ? t("Åpen") : t("Friskmeldt")}>
      <Badge
        $backgroundColor={isOpen ? colors.greenHaze : colors.darkTeal}
        $color={isOpen ? theme.colorSuccessTextTertiary : colors.mint}
      >
        {trainId}
      </Badge>
    </DropsTooltip>
  );
};
